module.exports = __webpack_public_path__ + "static/media/circle.85d7ef8f.svg";